
  import {Component, Prop, Vue} from "vue-property-decorator";
  import {IAppMediaPopup} from "@/shared/AppMediaPopup/interfaces/app-media-popup.interface";
  import CameraTypeIcon from "@/components/CameraTypeIcon.vue";

  @Component({
    components: {
      CameraTypeIcon,
    }
  })
  export default class AppMediaPopupPhotoInfo extends Vue {
    @Prop() mediaFile: IAppMediaPopup.IMediaFile;
  }
